// extracted by mini-css-extract-plugin
export var first = "first__d7qE";
export var headingContainer = "heading-container__tX86";
export var paragraph = "paragraph__hTb6";
export var paragraphContainer = "paragraph-container__zHb2";
export var second = "second__YDXn";
export var third = "third__ENch";